import React, { useState } from "react";
import api from "src/rest/api";
import { Container, TemplatesList } from "./styles";

import moment from "moment";
import { nanoid } from "nanoid";
import { BiX } from "react-icons/bi";
import { HiOutlineDocumentDuplicate } from "react-icons/hi";
import { IoAddCircle } from "react-icons/io5";
import { ThreeDots } from "react-loader-spinner";
import { useMutation, useQuery } from "react-query";
import { WorkoutsIcon } from "src/assets/static/icons";
import SideListView from "src/components/SideListView";
import { useDialog } from "src/contexts/dialog-context";
import EmptyListInfo from "src/modules/protocols/components/EmptyListInfo";
import SelectWorkoutType from "src/modules/protocols/components/select-workout-type";
import WorkoutView from "src/modules/protocols/Plan/View/WorkoutView";
import { useOverlay } from "src/screens/checkout/OverlayContext";
import { labels } from "../../../assets/strings/labels";

import { twMerge } from "tailwind-merge";
import {
  CreateItem,
  Workout,
  WorkoutTypeString,
} from "../../../modules/fithub-shared/interfaces/workout";

// import { Container } from './styles';

const WorkoutTemplates: React.FC = () => {
  const [workout, setWorkout] = useState<string>();

  const { data, refetch, isLoading } = useQuery("workout-t", () =>
    api.post<Workout[]>("workouts/list-templates").then((res) => res.data),
  );

  const mutateWorkout = useMutation(
    (update: Workout) => api.post<Workout>("/workouts/save", update),
    {
      onSuccess: () => {
        console.log("Mutation successful, but 'workout-t' not refetched.");
        refetch();
      },
    },
  );

  const over = useOverlay();

  function unselect() {
    setWorkout(undefined);
  }

  function handleCreate() {
    over.setShow(
      <div
        style={{
          display: "flex",
          flex: 1,
          width: "100%",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <SelectWorkoutType
          onSetType={(wt) => {
            NewTemplate(wt);
            over.dismiss();
          }}
          dismiss={over.dismiss}
        />
      </div>,
    );

    setWorkout(undefined);
  }

  async function NewTemplate(type: number) {
    //TODO: Usar Workout[] array para contabilizar numeros de templates nomeados "Novo Template"'
    if (!data) return;

    const count = data.map((e) => e.title.startsWith("Novo Template")).length;

    await api
      .post<Workout>("workouts/create", {
        protocol: null,
        type: type,
        item: CreateItem(type),
        title: `Novo Treino ${count + 1}`,
        order: count, //usar Workout[] length para atribuir order DESC
      })
      .then(() => {
        refetch();
      })
      .catch(alert);
  }

  const dialog = useDialog();

  function Delete(id: string) {
    dialog.openDialog(
      labels.delete.workoutTemplateTitle,
      labels.delete.workoutTemplateSubtitle,
      () => {
        api
          .post("workouts/delete", { id: id })
          .then(() => {
            setWorkout(undefined);
            refetch();
          })
          .catch(alert);
      },
    );
  }

  const selected = data?.find((e) => e.id === workout);

  return (
    <Container className="row flex">
      <SideListView
        list={
          <TemplatesList>
            <div className="flex items-center p-2">
              <WorkoutsIcon
                style={{
                  display: "flex",
                  backgroundColor: "#ddd",
                  borderRadius: "50%",
                  padding: 10,
                  marginRight: 10,
                }}
                color="#666"
                size={48}
              />
              <div className="flex flex-1">
                <h1 className="font-bold uppercase">Treinos Template</h1>
              </div>
              <button
                onClick={handleCreate}
                className="flex items-center gap-2 rounded-full bg-primary-500 p-1.5 text-white"
              >
                <IoAddCircle color="white" />
                <p className="text-sm font-bold">CRIAR</p>
              </button>
            </div>

            {data && data.length > 0 ? (
              <ul style={{ paddingInline: 5 }}>
                {data.map((element) => {
                  return (
                    <li
                      key={nanoid()}
                      onClick={() => setWorkout(element.id)}
                      style={{
                        backgroundColor:
                          workout === element.id ? "#0002" : "#fff",
                      }}
                      className={twMerge("flex")}
                    >
                      <div className="flex items-center">
                        <HiOutlineDocumentDuplicate size={18} />
                        <div
                          style={{
                            flexDirection: "column",
                          }}
                        >
                          <p className="title">{`${element.title}${element.cache ? "*" : ""}`}</p>

                          <p className="subtitle">
                            {WorkoutTypeString(element.type)}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-row items-center gap-1">
                        <p className="date">
                          {moment(element.created_at).format("DD/MM/yyyy")}
                        </p>
                        <button
                          onClick={() => Delete(element.id)}
                          className="group-hover:"
                        >
                          <BiX className="rounded-full hover:bg-zinc-300 hover:text-red-500" />
                        </button>
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="m-auto flex h-full flex-1 items-center justify-center">
                {isLoading ? (
                  <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="#000"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    visible={true}
                  />
                ) : (
                  <EmptyListInfo
                    Icon={WorkoutsIcon}
                    type={"Treinos Template"}
                  />
                )}
              </div>
            )}
          </TemplatesList>
        }
        content={
          selected ? (
            <div
              className="fade-in"
              style={{
                flexDirection: "column",
                flex: 1,
                padding: 5,
                position: "relative",
              }}
            >
              <WorkoutView
                key={workout}
                workout={selected}
                unselect={() => setWorkout(undefined)}
                mutation={mutateWorkout}
              />
            </div>
          ) : (
            <div
              style={{
                flex: 1,
                width: "100%",
                justifyContent: "center",
              }}
            >
              <p>Selecione um Treino Template</p>
            </div>
          )
        }
        onGoBack={unselect}
        view={workout ? "CONTENT" : "LIST"}
      />
    </Container>
  );
};

export default WorkoutTemplates;
